<template>
    <div class="content">

        <div class="page-header">
            <div class="page-title">
                <h3>Hallinta</h3>
                <!--
                <div>
                    <a href="product-list.html" class="btn btn-outline-primary active" title="List"
                       data-toggle="tooltip">
                        <i class="fa fa-th-list"></i>
                    </a>
                    <a href="product-grid.html" class="btn btn-outline-primary ml-2" title="Grid"
                       data-toggle="tooltip">
                        <i class="fa fa-th-large"></i>
                    </a>
                </div>
                -->
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-4">
                        <div class="card">
                            <div class="card-body">
                                <p><a class="btn btn-primary" href="/credits/">Luottojärjestelmä</a></p>
                                <p><a class="btn btn-primary" href="/osinkoja/">Osinkoja-hallinta</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Frontpage"
    }
</script>

<style scoped>

</style>
